import { LpAdSlider } from '../../../molecules/lp/ad/LpAdSlider';
import { LpAdResultSlide } from '../../../molecules/lp/ad/LpAdResultSlide';

import SliderImg001 from '../../../../static/image/lp/voice_slider001.png';
import SliderImg002 from '../../../../static/image/lp/voice_slider002.png';
import SliderImg003 from '../../../../static/image/lp/voice_slider003.png';
import SliderImg004 from '../../../../static/image/lp/voice_slider004.png';
import { SERVICE_NAME } from '../../../../const/Service';

export const LpAdSuccessStory = (): JSX.Element => {
  return (
    <LpAdSlider
      title={'未経験から続々とエンジニアに！'}
      dataGtm="result"
      supplement={`※こちらの受講生は${SERVICE_NAME}に加えてマンツーマンレッスンもご利用いただいた方々です。`}
    >
      <LpAdResultSlide
        image={SliderImg001}
        name={'羽多野遼佑'}
        comment={'作ったアプリがコンテストで特別賞を受賞し、サイト制作案件を受注できました。'}
      />
      <LpAdResultSlide
        image={SliderImg002}
        name={'伊藤走'}
        comment={'自分が欲しかったアプリを作れる技術がつき、iOSエンジニアとして転職成功できました。'}
      />
      <LpAdResultSlide
        image={SliderImg003}
        name={'南條伶央'}
        comment={'オリジナルアプリでポテンシャルをアピールし、XRエンジニアとして転職できました。'}
      />
      <LpAdResultSlide
        image={SliderImg004}
        name={'樋口大輔'}
        comment={'スクールで学んだことを応用し、インターン先で実践的な開発ができるようになりました。'}
      />
    </LpAdSlider>
  );
};
